/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Telugu2Inputs */

const en__field__enum_foreignlanguages_telugu2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Telugu2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telugu`)
};

const de__field__enum_foreignlanguages_telugu2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Telugu2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telugu`)
};

/**
* | output |
* | --- |
* | "Telugu" |
*
* @param {_Field__Enum_Foreignlanguages_Telugu2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_telugu2 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Telugu2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Telugu2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_telugu2(inputs)
	return de__field__enum_foreignlanguages_telugu2(inputs)
});
export { _field__enum_foreignlanguages_telugu2 as "_field__enum_foreignLanguages_Telugu" }